<template>
  <v-container class="white-wrapper" fluid ref="con">
    <div
      style="
        max-width: 25rem;
        margin: 0 auto;
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 0 1rem;
      "
    >
      <input type="hidden" id="refferral-code" :value="refferalUrl" readonly />
      <v-list class="list-container">
        <v-list-group>
          <template v-slot:activator>
            <v-list-item-title class="d-flex align-center list-item-height">
              <span class="list-title">{{ $t('config.lockUp') }}</span>
            </v-list-item-title>
          </template>
          <v-list-item>
            <div class="more_list" v-if="lockupList.length > 0">
              <div class="due" v-for="(item, idx) in lockupList" :key="item.id">
                <div class="rockup_due">
                  {{ $moment(item.created_at).format('YYYY-MM-DD') }} ~
                  {{ $moment(item.release_time).format('YYYY-MM-DD') }}
                </div>
                <div class="status">
                  <div
                    :class="
                      'rockup_status' +
                      (item.available === 0 && item.status === 0
                        ? ' error--text'
                        : ' success--text')
                    "
                  >
                    {{
                      item.available === 0 && item.status === 0
                        ? '● LOCKUP'
                        : '● OPEN'
                    }}
                  </div>
                  <div class="rockup_coin">
                    {{ parseFloat(item.locked_amount) }} {{ item.token_type }}
                  </div>
                </div>
                <v-divider
                  v-if="idx < lockupList.length - 1"
                  class="ma-5"
                ></v-divider>
              </div>
            </div>
            <div class="more_list" v-else>
              <div class="rockup_due">
                {{ $t('config.noLockUp') }}
              </div>
            </div>
          </v-list-item>
        </v-list-group>
        <v-list-group>
          <template v-slot:activator>
            <v-list-item-title class="d-flex align-center list-item-height">
              <span class="list-title">{{ $t('config.store') }}</span> <!--매장-->
            </v-list-item-title>
          </template>
          <v-list-item>
            <div class="more_list" v-if="user.psite">
              <div class="rockup_due">
                {{ user.psite }}
              </div>
            </div>
            <div class="more_list" v-else>
              <!--매장이 업습니다. -->
              <div class="rockup_due"> {{$t('config.storeNone')}}</div> 
            </div>
          </v-list-item>
        </v-list-group>
        <v-list-group>
          <template v-slot:activator>
            <v-list-item-title class="d-flex align-center list-item-height">
              <!--추천인-->
              <span class="list-title">{{$t('config.recommender')}}</span>
            </v-list-item-title>
          </template>
          <v-list-item>
            <div class="more_list" v-if="user.recommend">
              <div class="rockup_due">
                {{ user.recommend }}
              </div>
            </div>
            <div class="more_list" v-else>
              <!--추천인이 없습니다.-->
              <div class="rockup_due">{{$t('config.recommenderNone')}} </div>
            </div>
          </v-list-item>
        </v-list-group>
 
        <!-- v-show="this.$store.state.user.is_admin > 0 || ( this.$store.state.user.is_bill > 0 && this.$store.state.user.grade > 0 )" -->
        <v-list-item class="list-item-height" link to="/config/recommend" >
          <v-list-item-title>
            <span class="list-title">{{$t('config.ReferralList')}}</span>
          </v-list-item-title>
        </v-list-item>

        <v-list-item class="list-item-height" link to="/config/cards">
          <v-list-item-title>
            <span class="list-title">{{$t('config.TradeHistory')}}</span>
          </v-list-item-title>
        </v-list-item>


        <v-list-item class="list-item-height" link to="/config/history/point">
          <v-list-item-title>
            <span class="list-title">{{$t('config.PaymentHistory')}}</span>
          </v-list-item-title>
        </v-list-item>

        <v-list-item class="list-item-height" link to="/config/history/eth">
          <v-list-item-title>
            <span class="list-title">{{ $t('config.transHistory') }}</span>
          </v-list-item-title>
        </v-list-item>

        <v-list-item class="list-item-height" link to="/config/swap">
          <v-list-item-title>
            <span class="list-title">{{$t('config.swapCoin')}}</span>
          </v-list-item-title>
        </v-list-item>

        <!-- 검수용 제외 -->
      

        <v-list-item class="list-item-height" link to="/config/nft">
          <v-list-item-title>
            <span class="list-title">NFTs Register</span>
          </v-list-item-title>
        </v-list-item>

        <v-list-item class="list-item-height" link to="/nft">
          <v-list-item-title>
            <span class="list-title">NFTs</span>
          </v-list-item-title>
        </v-list-item> 

        <v-list-item class="list-item-height" link to="/config/news/lists">
          <v-list-item-title>
            <span class="list-title">{{$t('config.Notice')}}</span>
          </v-list-item-title>
        </v-list-item>

        <!-- 
          <v-list-item class="list-item-height" link to="/config/test" v-if="user.id==577 || user.id==47">
          <v-list-item-title>
            <span class="list-title">테스트 페이지 </span>
          </v-list-item-title>
        </v-list-item> 
      -->

        
      </v-list>
      <v-list class="list-container">
        <v-list-item class="list-item-height" @click="logoutDialog = true">
          <v-list-item-title>
            <span class="list-title logout_title">{{
              $t('config.logOut')
            }}</span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </div>

    <v-dialog
      v-model="logoutDialog"
      max-width="19rem"
      @click:outside="logoutDialog = false"
    >
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text
          style="
            min-height: 5rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          "
        >
          <div>
            {{ $t('config.logoutMessage') }}
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-0">
          <v-btn width="50%" text large @click="logoutDialog = false">
            {{ $t('cancel') }}
          </v-btn>
          <v-divider vertical></v-divider>
          <v-btn
            width="50%"
            color="primary"
            text
            large
            @click.prevent="onClickLogout"
          >
            {{ $t('config.logOut') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="messageDialog"
      max-width="19rem"
      @click:outside="messageDialog = false"
    >
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text
          style="
            min-height: 5rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          "
        >
          <v-icon color="error" large> mdi-alert-circle-outline </v-icon>
          

          <div class="text-center mt-3">
            {{ $t('config.withdrawMessage2') }}
          </div>
          <div class="text-center error--text">
            {{ $t('config.withdrawMessage3') }}
          </div>
          <div class="text-center">
            {{ $t('config.withdrawMessage4') }}
          </div>
          <div class="text-center">
            {{ $t('config.withdrawMessage5') }}
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-0">
          <v-btn width="50%" text large @click="messageDialog = false">
            {{ $t('cancel') }}
          </v-btn>
          <v-divider vertical></v-divider>
          <v-btn width="50%" color="error" text large @click="submitWithdraw">
            {{ $t('config.withdraw') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import MessageDialog from '../../components/MessageDialog.vue'
export default {
  components: {
    MessageDialog,
  },
  data() {
    return {
      lockupList: [],
      shareToggle: false,
      top: 0,
      langDialog: false,
      selectedLocale: '',
      messageDialog: false,
      message: '',
      logoutDialog: false,
    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
    refferalUrl() {
      return `${window.location.protocol}//${window.location.host}/#/signup/${this.user.referral_code}`
    },
  },
  methods: {
    onClickLogout() {
      // LOGOUT 변이 실행 후 리다이렉트
      this.$store.dispatch('LOGOUT').then(() => this.$router.push('/signin'))
    },
    copyCode() {
      let codeToCopy = document.querySelector('#refferral-code')
      codeToCopy.setAttribute('type', 'text')
      codeToCopy.select()

      const bottom = this.$refs.sharePosition.getBoundingClientRect().bottom
      this.top = bottom + 'px'
      try {
        // console.log(navigator)
        // if (window.androidBridge || window.webkit) {
        //   this.shareToggle = true
        // } else
        if (navigator.share) {
          navigator
            .share({
              text: this.$t('config.shareMessage'),
              url: this.refferalUrl,
            })
            .then(() => {
              this.$store.dispatch('toast', {
                toast: true,
                toast_msg: this.$t('config.shareSuccess'),
                timeout: 2000,
              })
            })
            .catch((err) => {
              if (err.toString().indexOf('cancellation') === -1) {
                throw err
              }
            })
        } else {
          var successful = document.execCommand('copy')

          if (successful) {
            this.$store.dispatch('toast', {
              toast: true,
              toast_msg: this.$t('config.copyMessage'),
              timeout: 2000,
            })
          } else throw new Error('fail')
        }
      } catch (err) {
        this.$store.dispatch('toast', {
          toast: true,
          toast_msg: this.$t('config.shareFail'),
          timeout: 2000,
        })
      }

      codeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    shareApi(type) {
      const info = `${this.$t('config.shareMessage')}${this.refferalUrl}`
      // console.log(type, info)
      if (typeof window.androidBridge != 'undefined') {
        window.androidBridge.bridge_share(type, info)
      }
      if (typeof window.webkit != 'undefined') {
        window.webkit.messageHandlers.share.postMessage({
          type: type,
          info: info,
        })
      }
    },
    closeOverlay() {
      this.shareToggle = !this.shareToggle
    },
    onClickWithdraw() {
      this.messageDialog = true
    },
    submitWithdraw() {
      this.$store
        .dispatch('withdraw')
        .then((res) => {
          this.messageDialog = false
          if (res.data && res.data.result) {
            this.$store.dispatch('toast', {
              toast: true,
              toast_msg: '탈퇴가 완료되었습니다.',
              timeout: 3000,
            })
            return this.$store.dispatch('LOGOUT')
          } else throw new Error('fail')
        })
        .then(() => this.$router.push('/signin'))
        .catch((err) => {
          this.$store.dispatch('toast', {
            toast: true,
            toast_msg: this.$t('errorServer'),
            timeout: 3000,
          })
        })
    },
  },
  created() {
    this.selectedLocale = this.$i18n.locale
    this.$store
      .dispatch('user_lockup_list')
      .then((res) => {
        // console.log(res)
        if (res.status === 200) this.lockupList = res.data
        else throw res
      })
      .catch((err) => {
        this.$store.dispatch('toast', {
          toast: true,
          toast_msg: this.$t('errorServer'),
          timeout: 3000,
        })
      })
  },
}
</script>

<style lang="scss" scoped>
.list-container,
.my_profile {
  max-width: 30rem;
  margin: 0 auto;
  width: 100%;
}
.v-list {
  // background-color: #f1f2f5 !important;
}
.my_profile {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 1rem auto;
}
.account_icon {
  width: 2.5rem;
  margin-left: 1rem;
}
.account_id {
  font-family: roboto;
  font-size: 1.1rem;
  margin-left: 0.6rem;
}
.rockup_list {
  border-bottom: 0.1rem solid #dbdbdb;
}
.more_list {
  margin-bottom: 0.5rem;
  width: 100%;
}
.due {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.status {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.rockup_due {
  display: flex;
  justify-content: flex-end;
  font-family: roboto;
  font-size: 0.9rem;
  color: #121212;
  margin-right: 1.3rem;
  margin-bottom: 0.2rem;
}
.rockup_status {
  font-family: roboto;
  font-size: 0.9rem;
  font-weight: bold;
  // color: #f65b5b;
  margin-right: 0.5rem;
}
.rockup_coin {
  font-family: roboto;
  font-size: 0.9rem;
  color: #121212;
  margin-right: 1.3rem;
}
.logout {
  width: 100%;
  height: 3rem;
  display: flex;
  justify-content: flex-start;
  background-color: #f1f2f5;
  padding-bottom: 1rem;
}
.logout_title {
  color: #5d5d5d !important;
}
.list-icon {
  width: 20px;
  margin-right: 0.5rem;
}
.list-title {
  font-weight: 600;
  color: #121212;
}
.list-item-height {
  min-height: 3.8rem;
  display: flex;
  align-items: center;
  .v-list-item__title {
    line-height: 3.8rem !important;
  }
}
</style>
